<template>
  <basic-container>
    <!-- serch -->
    <div class="search_group">
 
      <el-input :maxlength="30" v-model="title" size="small" placeholder="分组标签"></el-input>
      <el-select size="small"
              v-model="selectedId"
              clearable
              placeholder="请选择"
              @clear="handleClear"
              ref="selectUpResId"
            >
          <el-option hidden key="selectedId" :value="selectedId" :label="selectetName">
          </el-option>
          <el-tree
            :data="deptTreeList"
            :props="defaultProps"
            :expand-on-click-node="false"
            :check-on-click-node="true"
            @node-click="handleNodeClick"
          >
          </el-tree>
        </el-select>

      <el-button @click="searchAct" icon="el-icon-search" size="small" type="primary">搜索</el-button>
    </div>
    <!-- table -->
    <el-table :cell-style="{'text-align':'center'}" :header-cell-style="{'text-align':'center'}" :max-height="tableHeight"
       v-loading="listLoading" element-loading-text="加载中" border :data="tableData">
      <el-table-column prop="groupName" label="分组标签" width="300"></el-table-column>
      <el-table-column prop="videoCount" label="视频内数量" width="300"></el-table-column>
      <el-table-column prop="deptName" label="所属企业" ></el-table-column>

      <el-table-column fixed="right" width="250" label="操作">
        <template slot-scope="scope">
          <el-button  @click="openEdit(scope.row)" v-auth="'contentmanage_grouping_detail'" icon="el-icon-edit" size="small" type="text">查看</el-button>
          <el-button  @click="delDiscount(scope.row)" v-auth="'contentmanage_grouping_delete'" icon="el-icon-delete" size="small" type="text">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
     
    <!-- 新增修改弹窗 -->
    <el-dialog :title="checkItem.id?'查看详情':'查看详情'" :visible.sync="showEdit" append-to-body width="50%">
      <el-alert
        title=""
        type="info"
        >
         <template slot='title'>
           1、您可以在此改变该分组内的排序 <br />
           2、移出动作仅会将该视频移出分组，并不会删除该资源或改变该资源的状态
      </template>
      </el-alert>
      <el-table :data="gridData">
        <el-table-column type="index" width="100" label="显示顺序" align="center"></el-table-column>
        <el-table-column prop="name" label="视频标题"></el-table-column>
        <el-table-column prop="coverImageUrl" label="封面">
          <template slot-scope="scope">
              <img :src="scope.row.coverImageUrl" style="height: 50px"/>
          </template>
        </el-table-column>
        <el-table-column prop="playInfo" label="视频">
          <template slot-scope="scope">
              <img :src="scope.row.coverImageUrl" style="height: 50px"/>
          </template>
        </el-table-column>
        <el-table-column prop="reviewStatus" label="状态">
          <template slot-scope="scope">
            {{scope.row.reviewStatus | reviewStatus}}
          </template>  
        </el-table-column>       
        <el-table-column fixed="right" width="250" label="操作">
          <template slot-scope="scope">
            <el-button  @click="groupSort(scope.row,'up')" v-auth="'memberDiscount_change'" icon="el-icon-edit" size="small" type="text">上移</el-button>
            <el-button  @click="groupSort(scope.row,'down')" v-auth="'memberDiscount_change'" icon="el-icon-edit" size="small" type="text">下移</el-button>
            <el-button  @click="groupSort(scope.row,'remove')" v-auth="'memberDiscount_delete'" icon="el-icon-delete" size="small" type="text">移出</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-alert
        title=""
        type="info"
        >
         <template slot='title'>
           1、上移：调换该条视频与上一顺序视频的显示顺序 <br />
           2、下移：调换该条视频与下一顺序视频的显示顺序 <br />
           3、移出：清除该条数据的分组标签，移出操作需有二次确认（移出仅为将该视频的分组标签清除）
      </template>
      </el-alert>
      <div slot="footer" class="dialog-footer">
        
      </div>
    </el-dialog>
  </basic-container>
</template>

<script>
import { submitDiscount, commonProductList,  updateDiscountExamine } from '@/api/member'
import { findGroups , findByGroupAndDept ,groupSort,deleteGroup } from '@/api/contentManage'
import {getDeptTree} from "@/api/system/dept";
import {mapState} from "vuex";
import { debounce } from '@/util/common'
import pagination from '@/util/mixins/pagination'
export default {
  mixins: [pagination],
  data () {
    return {
      checkItem: {}, // 查看项
      showEdit: false, // 新增/修改弹窗
      gridData: [],
      deptTreeList:[],
      defaultProps: {
        children: 'children',
        label: 'title'
      },
      title:'',
      selectetName:'',
      selectedId:''

        //       gridData: [{
        //   date: '2016-05-02',
        //   name: '王小虎',
        //   address: '上海市普陀区金沙江路 1518 弄'
        // }, {
        //   date: '2016-05-04',
        //   name: '王小虎',
        //   address: '上海市普陀区金沙江路 1518 弄'
        // }, {
        //   date: '2016-05-01',
        //   name: '王小虎',
        //   address: '上海市普陀区金沙江路 1518 弄'
        // }, {
        //   date: '2016-05-03',
        //   name: '王小虎',
        //   address: '上海市普陀区金沙江路 1518 弄'
        // }],
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo
    })
  },
  mounted () {
    commonProductList().then(res => {
      if (res.data.code === 200) {
        this.productList = res.data.data
      } else {
        this.$message.error(res.data.msg)
      }
    })
    this.getList()
    getDeptTree(this.userInfo.tenant_id).then(res => {
      this.deptTreeList = res.data.data
    });
  },
  methods: {
    handleNodeClick(data) {
      // 这里主要配置树形组件点击节点后，设置选择器的值；自己配置的数据，仅供参考
      this.selectetName = data.title
      this.selectedId = data.id
      // 选择器执行完成后，使其失去焦点隐藏下拉框的效果
      this.$refs.selectUpResId.blur()
    },
    // 选择器配置可以清空选项，用户点击清空按钮时触发
    handleClear() {
      // 将选择器的值置空
      this.selectetName = ''
      this.selectedId = ''
    },
    // 获取列表
    getList () {
      this.listLoading = true
      let postData = {
         deptId: this.selectedId,
         groupName: this.title
      } 
      findGroups(postData).then(res =>{
         if (res.data.code === 200) {
          this.listLoading = false
          this.tableData = res.data.data
        } else {
          this.$message.error(res.data.msg)
        }
      }).catch(() => { this.listLoading = false })
    },
    // 打开新增或编辑
    openEdit (item) {
      this.showEdit = true
      console.log('[openEdit] 打开新增或者编辑' , item)
      if (item.deptId) {
        this.checkItem = {deptId:item.deptId,groupName:item.groupName}
        this.getGroupList() //获取分组数据
      } else {
        this.checkItem = {
          
        }
      }
    },
    getGroupList () {
      findByGroupAndDept(this.checkItem).then(res =>{
        console.log('[openEdit resultData ]' , res.data)
        if (res.data.code === 200) {
          this.gridData = res.data.data
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    groupSort(row,type) {
        console.log("[groupSort] " , row.id , type , `${row.id}/${type}`)
        if (type=='remove') {
          this.$confirm('确定要删除选中的数据吗？', '提示', {
            type: 'warning'
          }).then(() => {
            groupSort(`${row.id}/${type}`).then(res =>{
              if(res.data.code === 200){
                console.log(res.data.msg)
              this.$message.success(res.data.msg)
              }else{
                  this.$message.error(res.data.msg)
              }
              this.getGroupList() // 刷新分组数据
            })
          })
        } else {
            groupSort(`${row.id}/${type}`).then(res =>{
            if(res.data.code === 200){
              console.log(res.data.msg)
            this.$message.success(res.data.msg)
            }else{
                this.$message.error(res.data.msg)
            }
            this.getGroupList() // 刷新分组数据
          })
        }
    },
    // 删除
    delDiscount (item) {
      this.$confirm('确定要删除选中的数据吗？', '提示', {
        type: 'warning'
      }).then(() => {
        console.log({ groupName: item.groupName,deptId:item.deptId })
        deleteGroup({ groupName: item.groupName,deptId:item.deptId }).then(res => {
          if (res.data.code === 200) {
            this.getList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      })
    },
    // 保存新增或编辑
    saveEdit: debounce(function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          submitDiscount(this.checkItem).then(res => {
            if (res.data.code === 200) {
              this.showEdit = false
              this.getList()
            } else {
              this.$message.error(res.data.msg)
            }
          })
        } else {
          return false
        }
      })
    }, 300, false),
     
    // 修改审核状态
    changeCheck: debounce(function (item, status) {
      let postData = {
        bizRefrenceId: item.id,
        status: status
      }
      if (status !== 4) {
        if (!this.checkMark && status === 3) {
          this.$message.warning('请输入审核意见')
          return
        }
        postData.content = this.checkMark
      }
      updateDiscountExamine(postData).then(res => {
        if (res.data.code === 200) {
          this.showCheck = false
          this.getList()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }, 300, false)
  }
}
</script>

<style lang="scss" scoped>
  .el-image {
    width: 120px;
    height: 70px;
  }
  .viewbigImg {
    position: relative;
    top: -8px;
    left: 20px;
  }
  .el-dialog__body {
    padding: 10px 10px 0;
    .el-alert{
      margin-bottom: 10px;
    }
    .el-table{
      margin-bottom: 10px;
    }

  }

</style>
